import { createApp } from 'vue'
import router from '@/router'
import store from '@/store'
import 'virtual:svg-icons-register'
import App from './App.vue'

import './permission'

// 分页组件
import MtPagination from '@/components/MtPagination/index.vue'
import MtRightToolbar from '@/components/MtRightToolbar/index.vue'
import MtUpload from '@/components/MtUpload/index.vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.component('MtPagination', MtPagination)
app.component('MtUpload', MtUpload)
app.component('MtRightToolbar', MtRightToolbar)
app.use(store)
app.use(router)

app.mount('#app')
